import { schema } from 'normalizr';

export const objectSchema = new schema.Entity('objects');

export const objectListSchema = new schema.Array(objectSchema);